import { EnvironmentProviders } from '@angular/core';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara';

export function provideAppPrimeNG(): EnvironmentProviders {
  return providePrimeNG({
    theme: {
      preset: Lara,
      options: {
        darkModeSelector: '.layout-theme-dark',
      },
    },
  });
}
